import type { DivisionId } from '@multirx/shared/types/division.js';

/** Extrait l’id de division depuis une carte (ou un descendant). */
export function divisionIdFromCardTarget(target: EventTarget | null): DivisionId | null {
  if (!(target instanceof Element)) return null;
  const card = target.closest<HTMLElement>('.championship-division-card[data-division]');
  if (!card) return null;
  const raw = Number(card.dataset.division);
  if (!Number.isInteger(raw) || raw < 1 || raw > 4) return null;
  return raw as DivisionId;
}

/** True si le hover doit basculer le classement (évite les no-op). */
export function shouldSyncStandingsOnHover(
  currentDivision: number,
  hoveredDivision: DivisionId | null
): hoveredDivision is DivisionId {
  return hoveredDivision != null && hoveredDivision !== currentDivision;
}
